import { render } from "./GlobalSettings.vue?vue&type=template&id=1338b822&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"

import "./GlobalSettings.vue?vue&type=style&index=0&id=1338b822&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1338b822"]])

export default __exports__